<div class="dashboard-container">
    <div class="page-header">Reports Dashboard</div>
    <div class="dashboard-subheader">
        <div class="dashboard-subheader-oe" *ngIf="oeSubheader">
            <span class="dashboard-subheader-oe-title">Open Enrollment:</span>
            <span class="dashboard-subheader-oe-number">{{oeSubheader.beginDate | date : 'M/d/yy'}} - {{oeSubheader.endDate | date : 'M/d/yy'}}</span>
            <span [ngClass]="(oeSubheader.daysRemaining > 5)?'dashboard-subheader-oe-days-left-green':'dashboard-subheader-oe-days-left-red'">
                ({{oeSubheader.daysRemaining}} days remaining)
            </span>
        </div>
    </div>
    <div class="dashboard-content">
        <div *ngFor="let tile of tiles" class="dashboard-content-tile-container" 
            [ngClass]="tile.dashboardTileTypeId == DashboardTileTypeEnum.MultipleDonutGraphTileDetailsPerRow ? 'dashboard-gauge-container' : ''" >
            <app-dashboard-single-group-tile-details-per-row *ngIf="tile.dashboardTileTypeId == DashboardTileTypeEnum.SingleGroupTileDetailPerRow ||
                                                                    tile.dashboardTileTypeId == DashboardTileTypeEnum.MultipleGroupTileDetailPerRow"
                                                             [data]="tile">
            </app-dashboard-single-group-tile-details-per-row>

            <app-dashboard-single-group-tile-details-per-tile *ngIf="tile.dashboardTileTypeId == DashboardTileTypeEnum.SingleGroupTileDetailPerTile ||
                                                                    tile.dashboardTileTypeId == DashboardTileTypeEnum.SingleDonutGraphTileDetailPerTile"
                                                              [data]="tile">
            </app-dashboard-single-group-tile-details-per-tile>

            <app-dashboard-multi-gauge-graph-details-per-row *ngIf="tile.dashboardTileTypeId == DashboardTileTypeEnum.MultipleDonutGraphTileDetailsPerRow"
                                                            [data]="tile">
            </app-dashboard-multi-gauge-graph-details-per-row>
        </div>
    </div>
</div>
